export enum TutorialExtraCategoryIdEnum {
  All = 0,
  Latest = -1,
  Popular = -2,
  Saved = -3,
  Recommended = -4,
  History = -5,
}
